module.exports = __webpack_public_path__ + "static/img/19061C_1_R_20200812_fit.00684aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19061C_1_R_20200812_fit.png
// module id = sgoj
// module chunks = 0